import React from 'react'
import { CuiSelect } from 'front-lib'

const CustomSelect = props => {
  return <CuiSelect {...props} />
}

export default CustomSelect
